import config from '#/config';

import development from './env-development';
import production from './env-production';

export default config.environment !== 'production' ? development : production;
